import React, {Component} from "react";
import PropTypes from "prop-types";
import CreateNewEvent from "./CreateNewEvent";
import ListEvents from "./ListEvents";
import {_getListEvents} from "../../../../../services/apis/EventServices";
import Pagination from './Pagination'
import {changeQuerySearch, parseSearchQuery} from "../../../../../helpers/routes/RouterHelper"


const getInitPage = ()=>{
    const parsed = parseSearchQuery();
    return !!parsed.page ? parseInt(parsed.page, 10) : 1;
}

class EventsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            events: [],
            isChangingPage: false,
            numberOfPage: 0,
            total: 0,
            currentPage: getInitPage(),
            limit: 10,

        };
        this._handleOnChangePage = this._handleOnChangePage.bind(this);

    }


    componentDidMount() {
        const {currentPage} = this.state;
        this._fetchEvents(currentPage);
    }


    _fetchEvents(page = 1, limit = this.state.limit) {
        _getListEvents({page, limit})
            .then(result => {
                const {success, data} = result;
                if (success) {
                    this.setState({
                        events: data.docs,
                        numberOfPage: data.pages,
                        total: data.total,
                        currentPage: data.page,
                        limit: data.limit,
                        isChangingPage: false,
                    });
                }
            });
    }

    _handleOnCreateEvent = (event) => {
        const {currentPage, numberOfPage} = this.state;
        if (currentPage === numberOfPage) {
            this.setState(({events}) => ({
                events: [].concat(events, [event]),
            }));
        }
    };

    _handleOnRemoveEvent = (eventId) => {
        this.setState(({events}) => ({
            events: events.filter(event => event._id !== eventId),
        }));
    };

    _handleOnUpdateEvent = (eventId, evenUpdated) => {
        this.setState(({events}) => ({
            events: events.map(event => {
                if (event._id !== eventId) {
                    return event;
                }

                return evenUpdated;
            })
        }));

    };

    _handleOnChangePage(pageIndex, limit) {
        changeQuerySearch({page:pageIndex});
        this._fetchEvents(pageIndex, limit)
    }

    _handleDisableElement() {
        this.setState({
            isChangingPage: true,
        });
    }


    render() {
        return (
            <div className="EventsPage">
                <h1>Events</h1>

                <CreateNewEvent onCreated={this._handleOnCreateEvent}/>

                <ListEvents
                    onUpdate={this._handleOnUpdateEvent}
                    onRemove={this._handleOnRemoveEvent}
                    events={this.state.events}/>
                <Pagination
                    onChangePage={this._handleOnChangePage}
                    currentPage={this.state.currentPage}
                    limit={this.state.limit}
                    isChangingPage={this.state.isChangingPage}
                    onDisabled={this._handleDisableElement.bind(this)}
                    paginationInfo={{
                        numberOfPage: this.state.numberOfPage,
                    }}/>
            </div>
        );
    }
}

EventsPage.propTypes = {
    history: PropTypes.object
};

export default EventsPage;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/events/EventsPage/EventsPage.js